// extracted by mini-css-extract-plugin
export default {"quickTips":"QuickTips_quickTips__mQzXA","tipsGrid":"QuickTips_tipsGrid__KBJUj","tip":"QuickTips_tip__nmnkH","tipIcon":"QuickTips_tipIcon__-Ba9k"};